<template>
  <div class="animate__animated animate__fadeIn">
    <div class="d-flex">
      <div class="form">
        <el-form
          class="form__create"
          ref="formArchived"
          :model="dataForm"
          :rules="validForm"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="Phân loại mẫu">
                <el-select
                  v-model="dataForm.template_config_id"
                  clearable
                  filterable
                  placeholder="Chọn phân loại mẫu"
                  :disabled="viewMode == 'detail'"
                  @change="onChangeTemplateConfig"
                >
                  <el-option
                    v-for="item in dataDefault.listTemplateConfigs"
                    :key="item.id"
                    :label="item.category_name"
                    :value="item.id"
                  >
                    <span>{{ item.category_name }}</span>
                    <span class="template-code">{{ item.category_code }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Tên văn bản" prop="name">
                <el-input
                  v-model="dataForm.name"
                  clearable
                  @change="() => {dataForm.name = dataForm.name.trim()}"
                  :disabled="viewMode == 'detail'"
                  placeholder="Nhập tên văn bản"
                />
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Loại văn bản" prop="document_category_name">
                <el-input
                  v-model="dataForm.document_category_name"
                  clearable
                  @change="() => {dataForm.document_category_name = dataForm.document_category_name.trim()}"
                  placeholder="Nhập loại văn bản"
                  :disabled="viewMode == 'detail'"
                />
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Số văn bản" prop="code">
                <el-input
                  v-model="dataForm.code"
                  clearable
                  @change="() => {
                    dataForm.code = dataForm.code.trim()
                    dataForm.code = dataForm.code.toUpperCase()
                  }"
                  placeholder="Nhập số văn bản"
                  maxlength="50"
                  :disabled="viewMode == 'detail'"
                />
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Ghi chú" prop="description">
                <el-input
                  type="textarea"
                  v-model="dataForm.description"
                  @change="() => {dataForm.description = dataForm.description.trim()}"
                  placeholder="Nhập ghi chú"
                  :autosize="{ minRows: 4 }"
                  show-word-limit
                  maxlength="500"
                  resize="none"
                  :disabled="viewMode == 'detail'"
                />
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
      <div class="preview">
        <div
          class="right-side"
          v-if="fileUploadOption.fileArchived.fileList.length == 0"
        >
          <el-upload
            ref="upload"
            class="upload"
            :auto-upload="false"
            list-type="text"
            action
            :accept="fileUploadOption.fileArchived.accept"
            :on-change="uploadFile"
            :file-list="fileUploadOption.fileArchived.fileList"
            :limit="fileUploadOption.fileArchived.limit"
            drag
            :show-file-list="false"
          >
            <div class="el-upload__tip">
              <div
                class="
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                  mb-3
                "
              >
                <i class="icon isax-document-text-1 mb-3"></i>
                <p class="bold" style="font-size: 24px">
                  <span class="bold" style="color: #1e3cd7">Chọn file</span>
                  hoặc kéo thả file vào đây
                </p>
              </div>
              <p class="mb-3" style="color: #7e7e7e; line-height: 24px">
                Chỉ tải lên file có định dạng PDF<br />
                Kích thước tối đa 20MB
              </p>
            </div>
          </el-upload>
        </div>
        <div class="right-side" v-if="fileUploadOption.fileArchived.fileList.length > 0">
          <div class="preview__file-container">
            <FilePreview
              v-if="url"
              :file-url="url"
              extension="pdf"
            />
          </div>
          <div
            class="text-center remove__file-footer"
            v-if="url && viewMode != 'detail'"
            @click="removeFile"
          >
            <p class="text-white">Xóa file đã tải và chọn lại</p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-center action-row">
      <div class="text-right">
        <el-button
          class="btn__doc btn__doc-back"
          @click="fn_goBack()"
        >
          Quay lại
        </el-button>
        <el-button
          :disabled="!dataForm.doc_file.doc_id"
          class="btn__doc btn__doc-transfer"
          @click="fn_submitForm('create')"
          v-if="viewMode == 'create'"
        >
          Thêm mới
        </el-button>
        <el-button
          :disabled="!dataForm.doc_file.doc_id"
          class="btn__doc btn__doc-transfer"
          @click="fn_submitForm('update')"
          v-if="viewMode == 'update'"
        >
          Lưu
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import MethodService from "../../../../service/MethodService"
import DataService from "../../../../service/DataService"
import ExtensionService from "../../../../service/ExtensionService"
import FilePreview from "../../../../component/FilePreview.vue"
import ArchivedModel from './ArchivedModel'
import toastr from "toastr"
import DdaScanFilesApi from '../../../../moduleApi/DdaScanFilesApi'

export default {
  components: {
    FilePreview
  },
  data() {
    return {
      MethodService,
      url: undefined,
      localPreviewUrl: undefined,
      dataForm: MethodService.copyObject(ArchivedModel.dataForm),
      validForm: MethodService.copyObject(ArchivedModel.validForm),
      dataDefault: {
        listDocumentOp: DataService.listDocumentOp,
        listTemplateConfigs: []
      },
      viewMode: 'create',
      fileUploadOption: {
        fileArchived: {
          limit: 1,
          accept: ".pdf",
          dialogImageUrl: "",
          dialogVisible: false,
          fileList: [],
        }
      }
    }
  },
  methods: {
    onChangeTemplateConfig(templateId) {
      if (!templateId) return
      const template = this.dataDefault.listTemplateConfigs.find(item => item.id == templateId)
      if (!template) return

      const defaultValues = template.default_values || {}
      this.dataForm.name = defaultValues.name || this.dataForm.name
      this.dataForm.code = defaultValues.code || this.dataForm.code
      this.dataForm.document_category_name = defaultValues.document_category_name || this.dataForm.document_category_name
      this.dataForm.document_category_id = defaultValues.document_category_id || this.dataForm.document_category_id
      this.dataForm.description = defaultValues.description || this.dataForm.description

      this.$nextTick(() => {
        if (this.$refs.formArchived) {
          this.$refs.formArchived.clearValidate(['name', 'code', 'document_category_name', 'description'])
        }
      })
    },
    async fn_getDataById(id) {
      this.fileUploadOption.fileArchived.fileList = []
      const resApi = await DdaScanFilesApi.findById(id)
      this.dataForm = resApi.result
      console.log(resApi.result)
      if (resApi.result.doc_file && resApi.result.doc_file.doc_id) {
        let data = {
          id: resApi.result.doc_file.doc_id,
          name: resApi.result.doc_file.doc_name,
          url: ExtensionService.getDocumentPreviewUrl(resApi.result.doc_file.doc_id),
        }
        this.fileUploadOption.fileArchived.fileList.push(data)
        this.url = ExtensionService.getDocumentPreviewUrl(resApi.result.doc_file.doc_id)
      }
    },
    fn_goBack() {
      this.$router.push({
        name: 'Admin-Document-Archived-list'
      }).catch(() => {})
    },
    async fn_submitForm(type) {
      this.$refs["formArchived"].validate(async (valid) => {
        if (!valid) return
        const data = this.fn_buildSubmitPayload()
        if (!data.doc_file || !data.doc_file.doc_id) {
          toastr.warning("Vui lòng tải lên file PDF.")
          return
        }
        if (type == 'create') {
          try {
            await DdaScanFilesApi.create(data)
            toastr.success('Thêm mới thành công')
            this.fn_goBack()
          } catch (error) {
            const hasCreated = await this.fn_checkCreatedAfterError(data)
            if (hasCreated) {
              toastr.success('Thêm mới thành công')
              this.fn_goBack()
              return
            }
            toastr.error(error && error.detail ? error.detail : 'Thêm mới thất bại')
          }
        }
        if (type == 'update') {
          try {
            data.id = this.dataForm.id
            await DdaScanFilesApi.update(data)
            toastr.success('Cập nhật thành công')
            this.fn_goBack()
          } catch (error) {
            toastr.error(error && error.detail ? error.detail : 'Cập nhật thất bại')
          }
        }
      })
    },
    //Upload
    async uploadFile(file, fileList) {
      const rawFile = file.raw || file
      let lastIndexOfDot = file.name.lastIndexOf(".")
      let fileType = file.name.substr(lastIndexOfDot + 1, file.name.length).toLowerCase()
      if (fileType != 'pdf') {
        toastr.warning('File không đúng định dạng')
        fileList.pop()
        return
      }
      const isLt20M = rawFile.size / 1024 / 1024 <= 20

      if (!isLt20M) {
        toastr.warning('Dung lượng file PDF tải lên tối đa là 20MB.')
        fileList.pop()
        return
      }
      this.clearLocalPreviewUrl()
      this.localPreviewUrl = URL.createObjectURL(rawFile)
      this.url = this.localPreviewUrl
      ExtensionService.upload(file, "document-archived")
        .then((res) => {
          console.log('res', res)
          this.dataForm.doc_file.doc_id = res.result
          this.dataForm.doc_file.doc_name = file.name.slice(0, file.name.lastIndexOf("."))
          this.dataForm.doc_file.capacity = rawFile.size / 1024 / 1024
          this.dataForm.doc_file.type = fileType
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result
            }
          })
          this.fileUploadOption.fileArchived.fileList = fileList
        })
        .catch((err) => {
          toastr.error('Có lỗi xảy ra khi tải file lên.')
          this.clearLocalPreviewUrl()
          this.url = undefined
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1)
            }
          })
        })
    },
    clearLocalPreviewUrl() {
      if (this.localPreviewUrl) {
        URL.revokeObjectURL(this.localPreviewUrl)
        this.localPreviewUrl = undefined
      }
    },
    removeFile() {
      this.clearLocalPreviewUrl()
      this.url = undefined
      this.fileUploadOption.fileArchived.fileList = []
      this.dataForm.doc_file.doc_id = undefined
    },
  },
  created() {

  },
  mounted() {
    console.log(
      this.$route.name
    );
    if (this.$route.name == 'Admin-Document-Archived-detail') this.viewMode = 'detail'
    if (this.$route.name == 'Admin-Document-Archived-update') this.viewMode = 'update'
    if (this.$route.params.id) this.fn_getDataById(this.$route.params.id)
  },
  beforeDestroy() {
    this.clearLocalPreviewUrl()
  }
}
</script>
<style lang="scss" scoped>
.archived-form-page {
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-width: 100%;
}
.content-row {
  flex: 1;
  min-height: 0;
  flex-wrap: nowrap;
  overflow: hidden;
}
.left-side,
.preview {
  height: 100%;
  min-height: 0;
}
.action-row {
  flex-shrink: 0;
  padding-top: 10px;
}
::v-deep .el-form-item__label {
  font-weight: bold;
  text-align: left;
}
::v-deep .form__create {
  height: 100%;
  overflow-y: auto;
  padding: 16px 10px 10px;
}
::v-deep .el-textarea {
  .el-textarea__inner {
    border-radius: 0;
    box-shadow: none !important;
    border-radius: 5px !important;
    padding-bottom: 15px;
  }
  .el-input__count {
    background: transparent;
    right: 4px;
    bottom: -6px;
  }
}
::v-deep .right-side {
  background-color: #d0d5d9;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .upload { width: 100%; }
  .download-ref {
    color: rgb(30, 60, 215);
    line-height: 24px;
    position: absolute;
    top: 36%;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .icon {
    font-size: 74px !important;
    color: black !important;
  }
  .el-upload-dragger {
    padding: 20px;
    background-color: transparent;
    width: 100%;
    height: auto;
    .el-upload__tip {
      p {
        font-size: 14px;
      }
    }
  }
  .remove__file-footer {
    flex-shrink: 0;
    background-color: rgba(41, 45, 50, 0.7);
    width: 100%;
    padding: 10px;
    transition: 0.3s ease;
    cursor: pointer;
    &:hover {
      background-color: rgba(41, 45, 50, 0.95);
    }
  }
  .preview__file-container {
    background: #bebebe;
    width: 100%;
    height: calc(100% - 48px);
    box-shadow: 7px 7px 21px -7px rgb(0, 0, 0, 30%);
    overflow: auto;
    position: relative;
  }
}
::v-deep .el-upload {
  position: relative;
  display: block;
}
.template-code {
  float: right;
  color: #8492a6;
  font-size: 12px;
}
::v-deep .custom-label {
  width: 390px;
  align-items: center;
  justify-content: space-between;
  .el-switch {
    .el-switch__core {
      border-radius: 10px;
      &:after {
        border-radius: 10px;
      }
    }
  }
}
::v-deep .el-card {
  border-radius: 0 !important;
  border: none;
  .el-card__body { padding: 5px; }
  .el-form { padding: 20px 10px 10px; }
}
::v-deep .el-input__inner {
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-card--form {
  border: 1px solid rgb(126, 126, 126);
  padding: 3px 3px 3px 0;
  height: 100%;
  .el-card__body {
    height: 100%;
    overflow: hidden;
  }
}
::v-deep .form__create::-webkit-scrollbar,
::v-deep .preview__file-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .form__create::-webkit-scrollbar-track,
::v-deep .preview__file-container::-webkit-scrollbar-track {
  background: #f6e6d8;
}
::v-deep .form__create::-webkit-scrollbar-thumb,
::v-deep .preview__file-container::-webkit-scrollbar-thumb {
  background: var(--orange);
  border-radius: 8px;
}
::v-deep .form__create,
::v-deep .preview__file-container {
  scrollbar-color: var(--orange) #f6e6d8;
  scrollbar-width: thin;
}
@media (max-width: 1190px) {
  .archived-form-page {
    height: auto;
    overflow: visible;
  }
  .content-row {
    flex-wrap: wrap;
  }
  .left-side,
  .preview {
    height: auto;
  }
  ::v-deep .right-side {
    min-height: 420px;
  }
  ::v-deep .btn__doc { margin-bottom: 10px; }
}
</style>
